// Override Settings
var bcSfSearchSettings = {
    search: {
        //suggestionMode: 'test'
        //suggestionPosition: 'left',
        suggestionWidth: 300,
    }
};

// Customize style of Suggestion box
BCSfFilter.prototype.customizeSuggestion = function(suggestionElement, searchElement, searchBoxId) {
};

// Build number of Search result
BCSfFilter.prototype.buildSearchResultNumber = function(data) {
    var content = '';
    var searchTerm = this.escape(this.getSearchTerm());
    if (searchTerm != null) {
        if (data.total_product <=1 ) {
          	content = bcSfFilterConfig.label.search_result_number_one;
        } else {
			content = bcSfFilterConfig.label.search_result_number_other;
        }
        content = content.replace(/{{ count }}/g, data.total_product).replace(/{{ terms }}/g, searchTerm);
    }
    jQ('.' + this.class.searchResultNumber).html(content);
};

BCSfFilter.prototype.beforeBuildSearchBox = function(id) {
    jQ(document).ready(function() {
        $(document).off('submit', '.search-form, #search-form');
    });
};